<template>
  <div id="alterations">
    <div class="header flex-between">
      <div class="header-text">
        <h1>接口日志查询</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="searchList"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.clearquerycriteria"
          icon="el-icon-delete"
          @click="eliminate"
          >清除查询条件</el-button
        >
        <el-button
          v-if="jurisdiction.resendpermission"
          icon="el-icon-refresh-right"
          @click="ResendApi"
          >重新发送</el-button
        >
        <el-button
          v-if="jurisdiction.exportpermissions"
          icon="iconfont icon-chakan1"
          @click="exportShow = true"
          >导出</el-button
        >
        <el-button
          v-if="jurisdiction.downloadpermission"
          icon="el-icon-download"
          @click="(downloadShow = true), getDownladList()"
          >下载</el-button
        >
      </div>
    </div>
    <!-- 首页查询卡 -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form label-width="100px" :model="Inquirycard" size="small">
          <el-row>
            <el-col :span="8">
              <el-form-item label="请求时间">
                <el-date-picker
                  style="width: 75%"
                  v-model="Inquirycard.datePicker"
                  type="datetimerange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="请求参数">
                <el-input
                  clearable
                  style="width: 75%"
                  v-model="Inquirycard.reqParam"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="接口类型">
                <el-select
                  style="width: 75%"
                  v-model="Inquirycard.interfaceID"
                  filterable
                >
                  <el-option
                    v-for="item in interfacetypeList"
                    :key="item.interfaceID"
                    :label="item.interfaceName"
                    :value="item.interfaceID"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="请求类型">
                <el-select style="width: 75%" v-model="Inquirycard.reqType">
                  <el-option label="所有" value=""></el-option>
                  <el-option label="CRM调用外部接口" :value="true"></el-option>
                  <el-option
                    label="外部接口调用CRM接口"
                    :value="false"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="接口来源">
                <el-select
                  style="width: 75%"
                  v-model="Inquirycard.outApplicateionID"
                >
                  <el-option
                    v-for="item in interfacesourceList"
                    :key="item.outApplicateionID"
                    :label="item.appName"
                    :value="item.outApplicateionID"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="返回状态编码">
                <el-input
                  clearable
                  style="width: 75%"
                  v-model="Inquirycard.returnCode"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="返回状态">
                <el-select style="width: 75%" v-model="Inquirycard.returnState">
                  <el-option label="所有" value=""></el-option>
                  <el-option label="成功" value="1"></el-option>
                  <el-option label="失败" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <!-- 首页列表表格 -->
    <el-card shadow="never" class="centercard">
      <el-table
        :height="'calc(100vh - 32rem)'"
        size="small"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        v-loading="loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="45"> </el-table-column>
        <!-- radio -->
        <!-- <el-table-column width="40">
          <template slot-scope="scope">
            <el-radio
              :label="scope.$index"
              v-model="syradio"
              @change="adminRadioChange(scope.row)"
              >&nbsp;</el-radio
            >
          </template>
        </el-table-column> -->
        <el-table-column prop="interfaceID" label="接口编码"> </el-table-column>
        <el-table-column prop="interfaceName" label="接口名称">
        </el-table-column>
        <el-table-column prop="appName" label="来源"> </el-table-column>
        <el-table-column prop="apifirstTime" label="提交JOB时间" width="150%">
          <template slot-scope="scope">
            <div v-if="scope.row.apifirstTime !== null">
              {{ scope.row.apifirstTime | dateFormat }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="apiDoneTime" label="响应时间" width="150%">
          <template slot-scope="scope">
            <div v-if="scope.row.apiDoneTime !== null">
              {{ scope.row.apiDoneTime | dateFormat }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="响应时长"></el-table-column>
        <el-table-column prop="returnState" label="返回状态">
          <template slot-scope="scope">
            {{
              scope.row.returnState === true
                ? "True"
                : scope.row.returnState === false
                ? "False"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="returnCode"
          label="返回状态编码"
        ></el-table-column>
        <el-table-column
          prop="returnReason"
          label="返回信息"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="requestURL"
          label="请求地址"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="msgBody"
          label="请求参数"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="Inquirycard.pageNo"
          :page-sizes="[10, 15, 20, 25]"
          :page-size="Inquirycard.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>
    <div class="Resendd">
      <el-dialog
        width="20%"
        title="重新发送"
        :visible.sync="ResendFormVisible"
        :close-on-click-modal="false"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">重新发送</span>此接口?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Resend">确 定</el-button>
          <el-button @click="ResendFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="exporttc">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="导出接口日志记录"
        :visible.sync="exportShow"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否确定<span style="color: #ff0000">导出</span>接口日志记录?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="exportinterface">确 定</el-button>
          <el-button @click="exportShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!--  -->
    <el-dialog
      append-to-body
      width="50%"
      :visible.sync="downloadShow"
      title="下载文件"
    >
      <el-table
        size="small"
        class="table-style"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="downloadData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" width="55"></el-table-column>
        <el-table-column
          prop="startTime"
          label="开始执行时间"
        ></el-table-column>

        <el-table-column prop="endTime" label="结束执行时间"></el-table-column>

        <el-table-column prop="fileName" label="文件名"></el-table-column>

        <el-table-column prop="isComplate" label="状态">
          <template slot-scope="scope">
            {{ scope.row.isComplate ? "完成" : "执行中" }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下载">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-download"
              v-if="scope.row.isComplate"
              @click="download(scope.row.downloadUrl)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  tApiLogpageApi,
  tApiLoginterTypeApi,
  tApiLogprocessListApi,
  tApiLogoutAppListApi,
  tApiLogexportApi,
  reportexportListApi,
} from "@/api/logquery";
import { dateTimes } from "@/utils/auth";
export default {
  name: "Interfacelogquery",
  data() {
    return {
      jurisdiction: {
        search: false,
        clearquerycriteria: false,
        resendpermission: false,
        exportpermissions: false,
        downloadpermission: false,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      //   首页查询卡
      Inquirycard: {
        datePicker: "",
        reqDateStart: "", // 请求时间开始
        reqDateEnd: "", // 请求时间结束
        reqParam: "", // 请求参数
        interfaceID: "", // 接口类型
        reqType: "", // 请求类型
        outApplicateionID: "", // 接口来源
        returnCode: "", // 返回状态编码
        returnState: "", // 访问状态
        pageNo: 1, //页码
        pageSize: 20, //页数据
      },
      tableData: [],
      loading: false,
      total: 0,
      interfacetypeList: [],
      ResendFormVisible: false,
      tableselectiondata: [],
      ids: [],
      interfacesourceList: [],
      exportShow: false,
      downloadShow: false,
      downloadData: [],
    };
  },
  created() {
    this.homepagedataList();
    this.Interfacetype();
    this.Interfacesource();
    let Interfacelogquery = JSON.parse(
      localStorage.getItem("Interfacelogquery")
    );
    for (let i = 0; i < Interfacelogquery.length; i++) {
      if (Interfacelogquery[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Interfacelogquery[i].menuName == "清除查询条件") {
        this.jurisdiction.clearquerycriteria = true;
        continue;
      }
      if (Interfacelogquery[i].menuName == "重新发送") {
        this.jurisdiction.resendpermission = true;
        continue;
      }
      if (Interfacelogquery[i].menuName == "导出") {
        this.jurisdiction.exportpermissions = true;
        continue;
      }
      if (Interfacelogquery[i].menuName == "下载") {
        this.jurisdiction.downloadpermission = true;
        continue;
      }
    }
    console.log(Interfacelogquery);
  },
  computed: {
    // isMore() {
    //   return this.Inquirycard.pageNo >= this.Inquirycard.pages;
    // },
    // onLoading() {
    //   return this.loading || this.isMore;
    // },
  },
  methods: {
    searchList() {
      this.loading = true;
      this.Inquirycard.pageNo = 1;
      if (
        this.Inquirycard.datePicker &&
        this.Inquirycard.datePicker.length > 0
      ) {
        this.Inquirycard.reqDateStart = dateTimes(
          this.Inquirycard.datePicker[0]
        );
        this.Inquirycard.reqDateEnd = dateTimes(this.Inquirycard.datePicker[1]);
      } else {
        this.Inquirycard.reqDateStart = "";
        this.Inquirycard.reqDateEnd = "";
      }
      let data = {
        reqDateStart: this.Inquirycard.reqDateStart,
        reqDateEnd: this.Inquirycard.reqDateEnd,
        reqParam: this.Inquirycard.reqParam,
        interfaceID: this.Inquirycard.interfaceID,
        reqType: this.Inquirycard.reqType,
        outApplicateionID: this.Inquirycard.outApplicateionID,
        returnCode: this.Inquirycard.returnCode,
        returnState: this.Inquirycard.returnState,
        pageNo: this.Inquirycard.pageNo,
        pageSize: this.Inquirycard.pageSize,
        // pages: this.Inquirycard.pages,
      };
      tApiLogpageApi(data).then((res) => {
        if (res.success !== true) {
          this.$message.error("查询列表失败!");
          return;
        } else {
          this.$message.success("查询列表成功!");
          this.tableData = res.data.list;
          this.loading = false;
          this.total = res.data.total;
        }
      });
    },
    eliminate() {
      this.Inquirycard = {
        datePicker: "",
        reqDateStart: "", // 请求时间开始
        reqDateEnd: "", // 请求时间结束
        reqParam: "", // 请求参数
        interfaceID: "", // 接口类型
        reqType: "", // 请求类型
        outApplicateionID: "", // 接口来源
        returnCode: "", // 返回状态编码
        returnState: "", // 访问状态
        pageNo: 1, //页码
        pageSize: 20, //页数据
      };
      this.tableData = [];
      this.homepagedataList();
      this.$message.success("清除查询条件成功!");
    },
    homepagedataList() {
      if (
        this.Inquirycard.datePicker &&
        this.Inquirycard.datePicker.length > 0
      ) {
        this.Inquirycard.reqDateStart = dateTimes(
          this.Inquirycard.datePicker[0]
        );
        this.Inquirycard.reqDateEnd = dateTimes(this.Inquirycard.datePicker[1]);
      } else {
        this.Inquirycard.reqDateStart = "";
        this.Inquirycard.reqDateEnd = "";
      }
      let data = {
        reqDateStart: this.Inquirycard.reqDateStart,
        reqDateEnd: this.Inquirycard.reqDateEnd,
        reqParam: this.Inquirycard.reqParam,
        interfaceID: this.Inquirycard.interfaceID,
        reqType: this.Inquirycard.reqType,
        outApplicateionID: this.Inquirycard.outApplicateionID,
        returnCode: this.Inquirycard.returnCode,
        returnState: this.Inquirycard.returnState,
        pageNo: this.Inquirycard.pageNo,
        pageSize: this.Inquirycard.pageSize,
        // pages: this.Inquirycard.pages,
      };
      tApiLogpageApi(data).then((res) => {
        this.tableData = res.data.list;
        // this.Inquirycard.pages = res.data.pages;
        this.loading = false;
        this.total = res.data.total;
      });
    },
    // load() {
    //   this.loading = true;
    //   setTimeout(() => {
    //     this.Inquirycard.pageSize += 50; //页数据+50
    //     this.homepagedataList();
    //   }, 1000);
    // },
    handleSizeChange(val) {
      this.Inquirycard.pageSize = val;
      this.homepagedataList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.Inquirycard.pageNo = val;
      this.loading = true;
      this.homepagedataList();
      // console.log(`当前页: ${val}`);
    },
    Interfacetype() {
      tApiLoginterTypeApi({}).then((res) => {
        if (res.success) {
          this.interfacetypeList.push({
            interfaceID: "",
            interfaceName: "所有",
          });
          this.interfacetypeList.push(...res.data);
          // console.log(this.interfacetypeList);
        }
      });
    },
    Interfacesource() {
      tApiLogoutAppListApi({}).then((res) => {
        if (res.success) {
          this.interfacesourceList.push({
            outApplicateionID: "",
            appName: "所有",
          });
          this.interfacesourceList.push(...res.data);
        }
      });
    },
    ResendApi() {
      if (this.tableselectiondata.length == 0) {
        this.$message.warning("请选择数据,进行发送!");
      } else {
        this.ResendFormVisible = true;
      }
    },
    Resend() {
      this.tableselectiondata.forEach((item) => {
        this.ids.push(item.id);
      });
      let data = require("qs").stringify({
        ids: this.ids.join(","),
      });
      tApiLogprocessListApi(data).then((res) => {
        if (res.success == true) {
          this.$message.success("重新发送成功!");
          this.ids = [];
          data = [];
          this.ResendFormVisible = false;
          // console.log(res);
        } else {
          this.ids = [];
          this.$message.error("重新发送失败!");
        }
      });
    },
    exportinterface() {
      if (
        this.Inquirycard.datePicker &&
        this.Inquirycard.datePicker.length > 0
      ) {
        this.Inquirycard.reqDateStart = dateTimes(
          this.Inquirycard.datePicker[0]
        );
        this.Inquirycard.reqDateEnd = dateTimes(this.Inquirycard.datePicker[1]);
      } else {
        this.Inquirycard.reqDateStart = "";
        this.Inquirycard.reqDateEnd = "";
      }
      let data = {
        reqDateStart: this.Inquirycard.reqDateStart,
        reqDateEnd: this.Inquirycard.reqDateEnd,
        reqParam: this.Inquirycard.reqParam,
        interfaceID: this.Inquirycard.interfaceID,
        reqType: this.Inquirycard.reqType,
        outApplicateionID: this.Inquirycard.outApplicateionID,
        returnCode: this.Inquirycard.returnCode,
        returnState: this.Inquirycard.returnState,
        pageNo: this.Inquirycard.pageNo,
        pageSize: this.Inquirycard.pageSize,
      };
      tApiLogexportApi(data).then((res) => {
        console.log(res);
        this.exportShow = false;
        this.$message.success("导出成功,请在下载列表查看!");
      });
    },
    getDownladList() {
      reportexportListApi({
        groupName: "接口日志导出",
      }).then((response) => {
        console.log(response);
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = process.env.VUE_APP_BASE_API + src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    handleSelectionChange(val) {
      this.tableselectiondata = val;
      console.log(this.tableselectiondata);
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #e6e0af;
}
#alterations {
  height: 100%;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
.centercard {
  margin-top: 10px;
}
::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }
  .el-table .success-row {
    background: #ffffff;
  }

  .el-pagination {
    text-align: right;
  }
  .Resendd {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: right;
      background-color: #f2f2f2;
    }
    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 导出弹框样式

  .exporttc {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
</style>
<style>
.el-tooltip__popper {
  max-width: 15%;
}
</style>